import { CellText } from "components/Omnisearch/helpComponents/CellText";
import { StaffAssignee, getStaffAssigneeDisplayName } from "components/Submission/helpers/displayHelpers";

export function StaffAssigneeCell({
  staffAssignee,
}: {
  staffAssignee?: StaffAssignee | null;
}) {
  if (!staffAssignee) {
    return null;
  }
  const displayName = getStaffAssigneeDisplayName(staffAssignee);
  if (!displayName) {
    return null;
  }
  return (
    <CellText variant="body2" noWrap>
      {displayName}
    </CellText>
  );
}
